export default __webpack_public_path__ + "static/media/NHLPromoBG.58df6e62.png";